export function formatTime(time: string, shortenSmallScreen: boolean) {
  if (screen.width < 600 && shortenSmallScreen) {
    return formatTimeWithoutDate(time);
  }
  const parsedTime = new Date(time);
  return (
    twoDigitNumber(parsedTime.getHours()) +
    ':' +
    twoDigitNumber(parsedTime.getMinutes()) +
    ':' +
    twoDigitNumber(parsedTime.getSeconds()) +
    ' ' +
    twoDigitNumber(parsedTime.getDate()) +
    '-' +
    twoDigitNumber(parsedTime.getMonth() + 1) +
    '-' +
    parsedTime.getFullYear()
  );
}

export function formatTimeWithoutDate(time: string) {
  const parsedTime = new Date(time);
  return (
    twoDigitNumber(parsedTime.getHours()) +
    ':' +
    twoDigitNumber(parsedTime.getMinutes()) +
    ':' +
    twoDigitNumber(parsedTime.getSeconds())
  );
}

export function formatHourMinute(time: string) {
  const parsedTime = new Date(time);
  return (
    twoDigitNumber(parsedTime.getHours()) +
    ':' +
    twoDigitNumber(parsedTime.getMinutes())
  );
}

export function formatDateTime(date: Date) {
  return (
    `${date.getFullYear()}-${twoDigitNumber(
      date.getMonth() + 1,
    )}-${twoDigitNumber(date.getDate())}T` +
    twoDigitNumber(date.getHours()) +
    ':' +
    twoDigitNumber(date.getMinutes())
  );
}

export function formatDate(time: string) {
  const parsedTime = new Date(time);
  return (
    twoDigitNumber(parsedTime.getDate()) +
    '-' +
    twoDigitNumber(parsedTime.getMonth() + 1) +
    '-' +
    parsedTime.getFullYear()
  );
}

export function formatJSDate(date: Date) {
  return (
    twoDigitNumber(date.getDate()) +
    '-' +
    twoDigitNumber(date.getMonth() + 1) +
    '-' +
    date.getFullYear()
  );
}

export function formatDateInput(time: string) {
  const parsedTime = new Date(time);
  return (
    parsedTime.getFullYear() +
    '-' +
    twoDigitNumber(parsedTime.getMonth() + 1) +
    '-' +
    twoDigitNumber(parsedTime.getDate())
  );
}

export function twoDigitNumber(number: number): string {
  const stringifiedNumber = number.toString();
  return ('0' + stringifiedNumber).slice(-2);
}

type JWTBody = {
  scope: string[];
};

export function hasScope(token: string, scope: string): boolean {
  const jwtBody = parseJwt(token);
  for (let i = 0; i < jwtBody.scope.length; i++) {
    if (jwtBody.scope[i] == scope) {
      return true;
    }
  }
  return false;
}

function parseJwt(token: string): JWTBody {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

const RetourOrderStatusCreated = 'created';
const RetourOrderStatusReadyToCheck = 'ready-to-check';
const RetourOrderStatusBeingChecked = 'being-checked';
const RetourOrderStatusApproved = 'approved';
const RetourOrderStatusProcessed = 'processed';

export {
  RetourOrderStatusCreated,
  RetourOrderStatusReadyToCheck,
  RetourOrderStatusBeingChecked,
  RetourOrderStatusApproved,
  RetourOrderStatusProcessed,
};

export function convertRetourOrderStatusToReadable(status: string): string {
  switch (status) {
    case RetourOrderStatusCreated:
      return 'Aangemaakt';
    case RetourOrderStatusReadyToCheck:
      return 'Controle';
    case RetourOrderStatusBeingChecked:
      return 'Wordt gecontroleerd';
    case RetourOrderStatusApproved:
      return 'Goedgekeurd';
    case RetourOrderStatusProcessed:
      return 'Verwerkt';
    default:
      return '';
  }
}

export function convertReadableToRetourOrderStatus(status: string): string {
  switch (status) {
    case 'Aangemaakt':
      return RetourOrderStatusCreated;
    case 'Controle':
      return RetourOrderStatusReadyToCheck;
    case 'Wordt gecontroleerd':
      return RetourOrderStatusBeingChecked;
    case 'Goedgekeurd':
      return RetourOrderStatusApproved;
    case 'Verwerkt':
      return RetourOrderStatusProcessed;
    default:
      return '';
  }
}

const PickupOrderStatusInitState = 0;
const PickupOrderStatusReadyToBeProcessed = 1;
const PickupOrderStatusInitStateInProgress = 2;
const PickupOrderStatusReadyForPickUp = 3;
const PickupOrderStatusStartLoading = 4;
const PickupOrderStatusStartLoadingInProgress = 5;
const PickupOrderStatusBeingLoaded = 6;
const PickupOrderStatusLoadingDone = 7;
const PickupOrderStatusBooked = 8;
const PickupOrderStatusPackageReceiptCreated = 9;
const PickupOrderStatusPackageReceiptBeingSend = 10;
const PickupOrderStatusPackageReceiptSent = 11;
const PickupOrderStatusToBeRemoved = 100;
const PickupOrderStatusBeingRemoved = 101;
const PickupOrderStatusRemoved = 102;
const PickupOrderStatusManualActionRequired = 999;
const PickupOrderStatusOnCall = -1;

export {
  PickupOrderStatusInitState,
  PickupOrderStatusReadyToBeProcessed,
  PickupOrderStatusInitStateInProgress,
  PickupOrderStatusReadyForPickUp,
  PickupOrderStatusStartLoading,
  PickupOrderStatusStartLoadingInProgress,
  PickupOrderStatusBeingLoaded,
  PickupOrderStatusLoadingDone,
  PickupOrderStatusBooked,
  PickupOrderStatusPackageReceiptCreated,
  PickupOrderStatusPackageReceiptBeingSend,
  PickupOrderStatusPackageReceiptSent,
  PickupOrderStatusToBeRemoved,
  PickupOrderStatusBeingRemoved,
  PickupOrderStatusRemoved,
  PickupOrderStatusManualActionRequired,
  PickupOrderStatusOnCall,
};

export function converStatusToReadable(status: number): string {
  if (status == undefined) {
    return '';
  }
  switch (status) {
    case PickupOrderStatusInitState:
      return 'Ingevoerd';
    case PickupOrderStatusReadyToBeProcessed:
      return 'Kan worden klaargezet';
    case PickupOrderStatusInitStateInProgress:
      return 'Wordt klaargezet';
    case PickupOrderStatusReadyForPickUp:
      return 'Klaargezet';
    case PickupOrderStatusStartLoading:
      return 'Start laden';
    case PickupOrderStatusStartLoadingInProgress:
      return 'Start laden opgepakt';
    case PickupOrderStatusBeingLoaded:
      return 'Wordt geladen';
    case PickupOrderStatusLoadingDone:
      return 'Afboeken';
    case PickupOrderStatusBooked:
      return 'Afboeken';
    case PickupOrderStatusPackageReceiptCreated:
      return 'Pakbon aangemaakt';
    case PickupOrderStatusPackageReceiptBeingSend:
      return 'Pakbon verzonden';
    case PickupOrderStatusPackageReceiptSent:
      return 'Pakbon verzonden';
    case PickupOrderStatusManualActionRequired:
      return 'Handmatige actie vereist';
    case PickupOrderStatusOnCall:
      return 'Op afroep';
    case PickupOrderStatusToBeRemoved:
      return 'Kan opgeruimd';
    case PickupOrderStatusBeingRemoved:
      return 'Wordt opgeruimd';
    case PickupOrderStatusRemoved:
      return 'Opgeruimd';
    default:
      console.warn('unknown status int', status);
      return 'unknown status';
  }
}

export function converStatusToInt(status: string): number[] {
  switch (status) {
    case 'Ingevoerd':
      return [PickupOrderStatusInitState];
    case 'Kan worden klaargezet':
      return [PickupOrderStatusReadyToBeProcessed];
    case 'Wordt klaargezet':
      return [PickupOrderStatusInitStateInProgress];
    case 'Klaargezet':
      return [PickupOrderStatusReadyForPickUp];
    case 'Start laden':
      return [PickupOrderStatusStartLoading];
    case 'Start laden opgepakt':
      return [PickupOrderStatusStartLoadingInProgress];
    case 'Wordt geladen':
      return [PickupOrderStatusBeingLoaded];
    case 'Afboeken':
      return [PickupOrderStatusLoadingDone, PickupOrderStatusBooked];
    case 'Pakbon aangemaakt':
      return [PickupOrderStatusPackageReceiptCreated];
    case 'Pakbon verzonden':
      return [
        PickupOrderStatusPackageReceiptBeingSend,
        PickupOrderStatusPackageReceiptSent,
      ];
    case 'Handmatige actie vereist':
      return [PickupOrderStatusManualActionRequired];
    case 'Op afroep':
      return [PickupOrderStatusOnCall];
    case 'Kan opgeruimd':
      return [PickupOrderStatusToBeRemoved];
    case 'Wordt opgeruimd':
      return [PickupOrderStatusBeingRemoved];
    case 'Opgeruimd':
      return [PickupOrderStatusRemoved];
    default:
      console.warn('unknown pick order status string', status);
      return [0];
  }
}
